import { createStore } from "@/store";
const store = createStore();
let powersObj = {
    //基础权限
    allowLogin: false, //允许登录
    mySetting: false, //修改个人信息

    //工作桌面
    appointPictureNeed: false, //我的邀约
    desktopAuthor: false, //投稿人模式
    desktopEditor: false, //用稿人模式
    desktopManager: false, //管理者模式

    //个人图库
    allowMyGallery: false, //开启个人图库
    browseUnPicture: false, //查看未整理图片
    myAtlas: false, //管理个人图集
    createAtlas: false, //创建图集
    myFace: false, //人脸识别管理
    openLocalDisk: false, //开启本地共享盘
    createPrivateAtlas: false, //创建私有图集
    createPublicAtlas: false, //创建公共图集

    //图片中心
    allowGalleryCenter: false, //开启图片中心
    manageAtlas: false, //管理所有图集
    advSearchPicture: false, //高级搜索
    baseSearchPicture: false, //基础搜索
    documentCompile: false, //文稿编辑

    //使用图片
    allowApply: false, //开启用图功能
    pictureDownload: false, //创建图片打包
    picturePush: false, //创建图片推送
    pictureShare: false, //创建图片分享
    selectPicture: false, //选用图片

    //分享与推送
    allowTransmit: false, //开启分享与推送
    browseDownload: false, //打包下载
    browsePush: false, //查看推送
    browseShare: false, //查看分享

    //邀约与征稿
    allowGather: false, //开启邀约与征稿
    browseActivityArticle: false, //浏览征稿
    manageActivityArticle: false, //管理征稿
    manageAllActivityArticle: false, //管理所有征稿
    manageAllPictureActivity: false, //管理所有征稿活动
    manageAllPictureNeed: false, //管理所有图片邀约
    myPictureActivity: false, //管理征稿活动
    myPictureNeed: false, //管理图片邀约
    manageAllActivityLive: false, //管理所有直播
    myActivityLive: false, //管理我的直播

    //工作流-用户认证
    checkUserAuthInfo: false, //允许进入【工作流-用户认证】模块并完成审核操作
    searchUserAuthInfo: false, //通过搜索的方式查询已审核的认证信息
    outputUserAuthInfo: false, //导出所有认证信息

    //工作流-活动征稿
    checkPictureArticle: false, //对所有投稿进行审核管理
    checkPictureArticleFilter: false, //审核图片筛选任务
    rejectPictureArticleFilter: false, //屏蔽筛选任务中的投稿
    myPictureArticleFilter: false, //查看并管理自己创建的图片筛选任务
    manageAllPictureArticleFilter: false, //查看并管理所有人的筛选任务
    outputPictureArticleFilter: false, //在【查看结果】页面可以下载相应的数据

    //工作流-站点发布
    browseWebsiteCarousel: false, //查看轮播图信息
    manageWebsiteCarousel: false, //管理轮播图
    browseWebsiteInfo: false, //查看展示信息
    manageWebsiteInfo: false, //管理展示信息

    //数智中心
    allowAiCenter: false, //开启智能中心
    dataAnalysis: false, //数据分析
    manageIntelligentNode: false, //智能节点管理
    resourceLogCenter: false, //资源下载日志记录

    //平台运维
    allowOperationCenter: false, //开启平台运维
    manageNas: false, //共享盘管理
    manageThirdPartyAccess: false, //第三方接入管理
    operationCommand: false, //运维操作
    systemLogs: false, //系统日志

    //系统设置
    activityThemeConfig: false, //活动主题管理
    baseConfig: false, //基础设置
    libConfig: false, //图库管理
    pushConfig: false, //推送渠道管理
    roleConfig: false, //角色配置
    textConfig: false, //文本与协议管理
    userConfig: false, //用户管理
    websiteConfig: false, //站点管理
    securityConfig: false, //安全管理
    ssoConfig: false, //单点登录管理
    allowOperationCustomLabel: false, //管理资源自定义标签
    customLabelClassConfig: false, //标签分类管理
    customLabelConfig: false, //标签管理

    justAdmin: false, //只有超管可以查看的权限

    
    //回收站
    allowRecycleBin: false,  //开启回收站
    deleteCommand: false, //删除操作
    recoveryCommand: false, //恢复操作



}

let allowPushChannel = []
let allowLib = []

{
    // let powersObj = {
    //     //基础权限
    //     allowLogin: false,      //允许登录
    //     mySetting: false,      //修改个人信息

    //     //工作桌面
    //     desktopAuthor: false,      //投稿人模式
    //     desktopEditor: false,      //用稿人模式
    //     desktopManager: false,      //管理者模式

    //     //个人图库
    //     allowMyGallery: false,      //开启个人图库
    //     createAtlas: false,      //创建图集
    //     openLocalDisk: false,      //开启本地共享盘

    //     //图片中心
    //     allowGalleryCenter: false,      //开启图片中心
    //     browsePicture: false,      //浏览图集和图片
    //     searchPicture: false,      //搜素图集或图片
    //     selectPicture: false,      //选用图片

    //     //用图管理
    //     allowApply: false,      //开启用图功能
    //     pictureDownload: false,      //图片打包
    //     picturePush: false,      //图片推送
    //     pictureShare: false,      //图片分享

    //     //分享与推送
    //     allowTransmit: false,      //开启分享与推送
    //     browseDownload: false,      //打包下载
    //     browsePush: false,      //查看推送
    //     browseShare: false,      //查看分享

    //     //图片收集
    //     allowGather: false,      //开启图片收集
    //     createPictureActivity: false,      //创建征稿活动
    //     createPictureNeed: false,      //创建图片邀约
    //     deletePictureActivity: false,      //删除征稿活动
    //     deletePictureNeed: false,      //删除图片邀约
    //     updatePictureActivity: false,      //修改征稿活动
    //     updatePictureNeed: false,      //修改图片邀约

    // }
}
let powersList
if (store.state.user.powers) {
    powersList = store.state.user.powers
} else {
    powersList = localStorage.getItem("powers")
    powersList = JSON.parse(powersList)
}

function isPowers(object) {
    for (let key in object) {
        if (powersList.indexOf(key) !== -1) {
            object[key] = true
        } else {
            object[key] = false
        }
    }
}

function isPushChannel() {
    for (let i = 0; i < powersList.length; i++) {
        if (powersList[i].length > 12) {
            let start = powersList[i].substring(0, 11)
                // allowPushChannel.push(start)
            if (start === 'pushChannel') {
                allowPushChannel.push(powersList[i].slice(12))
            }
        }
    }
}

function isLib() {
    let libFlag
    if (powersList.indexOf('libConfig') !== -1) {
        powersList.splice(powersList.indexOf('libConfig'), 1)
        libFlag = true
    }

    for (let i = 0; i < powersList.length; i++) {
        if (powersList[i].length > 4) {
            let start = powersList[i].substring(0, 3)
            if (start === 'lib') {
                allowLib.push(powersList[i].slice(4))
            }
        }
    }
    if (libFlag) {
        powersList.push('libConfig')
    }
}
isPowers(powersObj)
isPushChannel()
isLib()

export { powersObj, allowPushChannel, allowLib, powersList }